import { Modal } from 'antd';
import moment from 'moment';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import ArrowDownIcon from '../../../components/UI/Icon-SVG/ArrowDownIcon';
import DeleteIcon from '../../../components/UI/Icon-SVG/DeleteIcon';
import GroupChatLargeIcon from '../../../components/UI/Icon-SVG/GroupChatLargeIcon';
import ProfileIcon from '../../../components/UI/Icon-SVG/ProfileIcon';
import Spinner from '../../../components/UI/Spinner/Spinner';
import { Context } from '../../../index';

import ChatListContextMenu, { ChatListContextMenuItem } from './ChatListContextMenu';

const List = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: auto;
  height: calc(100vh - 64px);
`;

const Item = styled.div`
  width: 100%;
  height: 85px;
  color: #a6b0cf;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 16px;
  cursor: pointer;
  svg.arrow path {
    fill: #a6b0cf;
  }

  &.active {
    background: #70a5ff;
    color: white;

    h3 {
      color: white;
    }

    svg.arrow path {
      fill: white;
    }
  }

  &:hover {
    background: #70a5ff;
    color: white;

    h3 {
      color: white;
    }

    svg.arrow path {
      fill: white;
    }
  }
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #397ef3;
  border-radius: 24px;

  img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background-size: cover;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 16px;
  overflow: hidden;
  white-space: nowrap;
`;

const ItemElementsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Name = styled.h3`
  font-size: 16px;
  color: black;
  margin: 0;
  font-weight: 400;
`;

const LastMessage = styled.p`
  font-size: 12px;
  margin: 0;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const Time = styled.p`
  font-size: 12px;
  margin: 0;
`;

const ChatList = ({
  chatRooms,
  isChatListLoading,
  activeChat,
  selectChat,
  isSupportChat = false,
}) => {
  const [anchorPoint, setAnchorPoint] = useState(null);
  const [selectedForDeletion, setSelectedForDeletion] = useState(null);
  const [contextMenuIsVisible, setContextMenuIsVisible] = useState(false);
  const [deleteConfirmModalIsVisible, setDeleteConfirmModalIsVisible] = useState(false);
  const history = useHistory();

  const { firestore, auth } = useContext(Context);
  const user = auth.currentUser;
  const userId = user?.uid;

  const hideMenu = () => {
    setContextMenuIsVisible(false);
  };

  const showDeleteModal = () => setDeleteConfirmModalIsVisible(true);
  const hideDeleteModal = () => setDeleteConfirmModalIsVisible(false);
  const deleteChat = () => {
    delete selectedForDeletion.data.users[userId];
    firestore
      .collection('chat_rooms')
      .doc(selectedForDeletion.id)
      .update({
        user_ids: selectedForDeletion.data.user_ids.filter((item) => item !== userId),
        users: selectedForDeletion.data.users,
      });
    hideDeleteModal();
    selectChat(null);
  };

  const renderItem = (item) => {
    // eslint-disable-next-line no-unsafe-optional-chaining
    const currentEpoch = item.data?.last_msg_epoch?.seconds ?? item.data?.last_msg_epoch * 1000;
    const time = moment.unix(currentEpoch).isSame(moment(), 'day')
      ? moment.unix(currentEpoch).format('LT')
      : moment.unix(currentEpoch).format('MM.DD h.mm A');
    // eslint-disable-next-line
    const AvatarValue = () => {
      if (item.data?.avatarUrl) return <img src={item.data?.avatarUrl} alt="profile" />;
      if (item.data?.room_type !== 0) return <GroupChatLargeIcon color="#fff" />;
      return <ProfileIcon color="#fff" />;
    };

    const handleContextMenu = (e) => {
      e.preventDefault();
      setAnchorPoint({ x: e.pageX, y: e.pageY });
      setContextMenuIsVisible(true);
      setSelectedForDeletion(item);
    };
    const handleAvatarClick = () => {
      if (item.data?.room_type === 0) {
        const otherUserId = item.data?.user_ids?.find((id) => userId !== id);
        otherUserId && history.push(`/profile/${otherUserId}`);
      }
    };

    return (
      <Item
        onContextMenu={handleContextMenu}
        key={item.id}
        onClick={() => selectChat?.(item.id)}
        className={activeChat === item.id && 'active'}
      >
        <Avatar onClick={handleAvatarClick}>
          <AvatarValue />
        </Avatar>
        <TextWrapper>
          <ItemElementsWrapper>
            <Name>{item.data?.chatName}</Name>
            <Time>{time}</Time>
          </ItemElementsWrapper>
          <ItemElementsWrapper>
            <LastMessage>{item.data?.last_msg}</LastMessage>
            <ArrowDownIcon />
          </ItemElementsWrapper>
        </TextWrapper>
        <ChatListContextMenu
          anchorPoint={anchorPoint}
          isVisible={contextMenuIsVisible}
          hideMenu={hideMenu}
        >
          <ChatListContextMenuItem onClick={showDeleteModal}>
            <DeleteIcon />
            <span>Delete chat</span>
          </ChatListContextMenuItem>
        </ChatListContextMenu>
      </Item>
    );
  };

  return (
    <List style={isSupportChat ? { backgroundColor: '#fff' } : {}}>
      <Modal
        title="Delete chat"
        visible={deleteConfirmModalIsVisible}
        onOk={deleteChat}
        onCancel={hideDeleteModal}
        okText="Delete"
      >
        <p>
          Do you really want to delete the chat &apos;{selectedForDeletion?.data?.chatName}&apos;?
        </p>
      </Modal>
      {isChatListLoading ? <Spinner /> : chatRooms?.map(renderItem)}
    </List>
  );
};

export default ChatList;
